export const METABASE_MANAGED_AI_FEATURE = "metabase-ai-managed";
export const METABASE_MANAGED_AI_PRODUCT_TYPE = "metabase-ai-managed";
export const METABASE_MANAGED_AI_TERMS_URL =
  "https://www.metabase.com/license/hosting";
export const METABASE_MANAGED_AI_UNIT_MULTIPLIER = 1_000_000;
